import React from "react";
import {
    Modal,
    Table,
    Typography,
    Button,
    Tooltip
} from "antd";
import { LinkOutlined, UserOutlined } from "@ant-design/icons";
import { StatusBadge } from "components";
import { biometricStatus } from "utils/static-data";

const { Text } = Typography;

const STATUS_CONFIG = {
    NOT_INITIATED:      { color: "#8c8c8c", icon: <UserOutlined />, label: "Biometria: Não iniciado", type: "initial" },
    CREATED:            { color: "#8c8c8c", icon: <UserOutlined />, label: "Biometria: Não iniciado", type: "initial" },
    IN_PROCESS:         { color: "#faad14", icon: <UserOutlined />, label: "Biometria: Em análise", type: "analysis" },
    CAPTURE_COMPLETED:  { color: "#faad14", icon: <UserOutlined />, label: "Biometria: Capturada", type: "analysis" },
    APPROVED:           { color: "#52c41a", icon: <UserOutlined />, label: "Biometria: Aprovado", type: "finish" },
    REJECTED:           { color: "#ff4d4f", icon: <UserOutlined />, label: "Biometria: Reprovado", type: "error" },
    EXPIRED:            { color: "#fa541c", icon: <UserOutlined />, label: "Biometria: Expirado", type: "error" },
};

const BiometricLinksModal = ({
    open,
    onClose,
    users = [],
}) => {

    const copy = async (url) => {
        if (!url) return;

        await navigator.clipboard.writeText(url);
    };

    const reasons = (user) => {
        const reasons = []
        if(user.biometricStatusReasons && user.biometricStatusReasons.length > 0) {
            reasons.filter(reason => reason != null).push(...user.biometricStatusReasons.map(reason => reason + " (biometria)"));
        }
        return reasons;
    }
    const capitalize = (text) => {
        if (!text) return "";

        const normalized = text.toLowerCase();
        return normalized.toLowerCase().charAt(0).toUpperCase() + normalized.slice(1);
    }

    const columns = [
        {
            title: "Nome",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Tipo",
            dataIndex: "relationshipType",
            key: "type",
            width: 170,
            render: (type) => (
                capitalize(type)
            ),
        },
        {
            title: "CPF",
            dataIndex: "cpf",
            key: "cpf",
            width: 170,
        },
        {
            title: "",
            width: 180,
            align: "center",
            render: (_, record) =>
                record.biometricUrl && (
                    <React.Fragment>
                        {record.biometricStatus !== 'APPROVED' &&
                        <Tooltip title="Copiar URL">
                            <Button
                                type="link"
                                icon={<LinkOutlined />}
                                onClick={() => copy(record.biometricUrl)}
                            >Copiar link</Button>
                        </Tooltip>}
                        <Tooltip title={STATUS_CONFIG[record.biometricStatus]?.label ?? "-"}>
                            <span style={{ color: STATUS_CONFIG[record.biometricStatus]?.color }}>
                                {STATUS_CONFIG[record.biometricStatus]?.icon}
                            </span>
                        </Tooltip>
                    </React.Fragment>
                ),
        },
    ];

    return (
        <Modal
            open={open}
            title="Links de Biometria"
            width={1000}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    Fechar
                </Button>,
            ]}
        >
            <Table
                rowKey="id"
                columns={columns}
                dataSource={users}
                pagination={false}
                bordered
                scroll={{ y: 450 }}
            />
        </Modal>
    );
};

export default BiometricLinksModal;